var styles = {"container":"bc-MaterialAssignmentDialogHeader__container"};

export { styles as default };
